module.exports = __webpack_public_path__ + "static/media/wip-full.efa68ffe.png";